<template>
    <div>
        <NavBar/>
        <div class="page">
            <div class="col left-sidebar">
                <p class="heading"> Meetings </p>
                <div class="section">
                    <p class="heading"> Upcoming Meetings </p>
                    <ul>
                        <li v-for="(meeting, index) in meetings" :key="index">
                            <img src="../assets/images/Victor.jpeg" alt="Meeting Icon">
                            <p>Time: {{ meeting.time }}</p>
                            <p>Name: {{ meeting.username }}</p>
                            <p>Zoom Link: <a :href="meeting.zoomLink">{{ meeting.zoomLink }}</a></p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from './../components/NavBar.vue'

export default {
    name: 'MeetingsPageView',
    components:{
         NavBar
    },

    data() {
        return {
            meetings: [
                { time: '10:00 AM', username: 'John', zoomLink: 'https://zoom.us/j/123456789' },
                { time: '2:00 PM', username: 'Alice', zoomLink: 'https://zoom.us/j/987654321' },
            ],
        };
    },
};
</script>

<style scoped>
.page {
    font-family: 'Your Font', sans-serif;
    color: #333;
    background-color: #3867AE; /* Set the page background to blue */
    min-height: 100vh; /* Full viewport height */
    padding: 20px;
    display: flex;
    justify-content: center; /* Center the .left-sidebar horizontally */
    align-items: flex-start; /* Align to the top */
}

.left-sidebar {
    background-color: #fff; /* Keep the sidebar white for contrast */
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    border-radius: 8px;
    width: 100%; /* Make the sidebar full-width */
    max-width: 600px; /* Or any max-width you prefer */
    margin: 20px auto; /* Center in the page */
    padding: 20px;
    box-sizing: border-box; /* Include padding in the width */
}

.heading {
    color: #000000; /* Changed to white for better contrast against blue background */
    font-size: 1.5em;
    margin-bottom: 10px;
    text-align: left; /* Align headings to the left */
}

.section {
    border-top: 2px solid #ffffff; /* Use a contrasting color for the section divider */
    padding-top: 20px;
}

ul {
    padding: 0;
    margin: 0;
}

li {
    list-style: none;
    padding: 10px 0;
    border-bottom: 1px solid #eee; /* Light border for list items */
    display: flex;
    align-items: center; /* Align items in the li */
    gap: 10px; /* Spacing between icon and text */
}

li:last-child {
    border-bottom: none;
}

img {
    width: 50px;
    height: 50px;
}

a {
    color: #ffcc00; /* Keep the specific yellow hue for links */
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

/* Style the buttons/links like the homepage ones */
a.button {
    background-color: #ffcc00; /* Use the brand yellow for buttons */
    color: #0044cc; /* Blue text on yellow button for contrast */
    padding: 10px 15px;
    border-radius: 20px;
    display: inline-block;
    margin-top: 20px;
    text-align: center;
    text-decoration: none;
}

a.button:hover {
    background-color: #ffbb00; /* A slightly darker yellow on hover */
}
</style>